module.exports = __webpack_public_path__ + "static/media/timelify-medium.4f5e1d6a.otf";